var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('c-box',{attrs:{"h":"100%"}},[_c('div',{staticClass:"home"},[_c('Header'),_c('c-heading',{staticClass:"heading",attrs:{"textAlign":"center","py":"27.5vh"}},[_vm._v(" Home Page ")]),_c('Footer')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }